export enum RESERVED_ROLES {
  SUPER_ADMIN = "Super Admin",
  USER = "User",
  CUSTOMER = "Customer",
  EVENT_ADMIN = "Event Admin",
}
